import { render } from "./PopupsInfoBlock.vue?vue&type=template&id=694b509d&scoped=true"
import script from "./PopupsInfoBlock.vue?vue&type=script&lang=js"
export * from "./PopupsInfoBlock.vue?vue&type=script&lang=js"

import "./PopupsInfoBlock.vue?vue&type=style&index=0&id=694b509d&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694b509d"]])

export default __exports__